import { useSession } from 'next-auth/react'

import { getUserId } from '@/helpers/getUserId'
import { useSelectedOrgUnitId } from '@/hooks/useSelectedOrgUnitId'

export interface OrgScope {
  customerId: ReturnType<typeof getUserId>
  orgUnitId: string
}

export const useOrgScopeSnapshot = (): (() => OrgScope) => {
  const { data: session } = useSession()
  const customerId = getUserId(session)
  const orgUnitId = useSelectedOrgUnitId()

  return () => ({ customerId, orgUnitId })
}
